module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('toolbar'), _vm._v(" "), _c('member-item', {
    staticStyle: {
      "position": "fixed",
      "z-index": "100"
    },
    attrs: {
      "item-data": _vm.itemData,
      "item-ref": _vm.itemRef,
      "show-dialog": _vm.store.showDialog
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "pa-0 mt-2"
  }, [_c('v-row', {
    attrs: {
      "row": ""
    }
  }, [_c('v-col', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.list), function(item) {
    return (item.status === _vm.$route.query.status || _vm.$route.query.status === undefined) ? [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-item', {
      key: item.name
    }, [_c('v-list-tile', {
      attrs: {
        "avatar": "",
        "ripple": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.show(item.ref)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(item.readableStatus)
      }
    })], 1)], 1)], 1)] : _vm._e()
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d602cdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Members.vue
// module id = 125
// module chunks = 1